export function formatInvoiceEur(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return '0.00';
  return n.toFixed(2);
}

export function formatInvoiceRsd(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return '0,00';
  return n.toLocaleString('sr-RS', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
